export default "<div class=\"container\">\n    <h1>Welcome</h1>\n</div>"